import React, { useRef, useEffect, useState } from 'react';

import { Container, Row, Col } from 'react-bootstrap';


const nodeHeight = 20;
const yMarg = 10;
const xMarg = 10;
const xPadding = 50;
const lineAdjustment = 2;
const debounceInterval = 500

const dayLabelY = 15
const personLabelY = 25
const calendarTopMargin = 30
const calendarLeftMargin = 30
const textMargin = 4

const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
const people = ["Tim", "Jennifer", "James", "Adelaide", "Therese"]
const personWidth = 50
const canvasHeight = 1000

const Calendar = ({ initialData, update, exit, editing, edit }) => {
	// console.log("Initial data Calendar: " + JSON.stringify(initialData))

	const canvasRef = useRef(null)

	const actionRef = useRef("1")
	const [action, setAction] = useState("1")
	const [dataInternal, setDataInternal] = useState(initialData?.calendarEvents == null ? { type: "calendar", calendarEvents: [], categories: [] } : initialData)
	const [stats, setStats] = useState({})
	const [copyState, setCopyState] = useState("Copy Image")
	const [downloadState, setDownloadState] = useState("Download")

	const [newCategory, setNewCategory] = useState({ name: "", color: "#000000" })

	const dataRef = useRef(dataInternal)
	const selectedNodeRef = useRef(null)
	const selectedNodeLocationRef = useRef(null)
	const selectedConnectionRef = useRef(null)
	const clickedNodeRef = useRef(null)
	const lastClickTimeRef = useRef(0)

	const clickOffsetXRef = useRef(0)
	const clickOffsetYRef = useRef(0)
	const isMouseDownRef = useRef(false)

	const [peopleFilter, setPeopleFilter] = useState({})
	const [editingData, setEditingData] = useState({ name: "", people: {}, days: {}, start: "", end: "", id: getUniqueId() })

	useEffect(() => {
		console.log("Calendar useEffect")
		dataRef.current = dataInternal
		const canvas = canvasRef.current
		const ctx = canvas.getContext('2d')
		ctx.lineWidth = 2;
		ctx.lineCap = "round";
		function addListeners() {
			canvas.addEventListener('mousedown', onMouseDown);
			canvas.addEventListener('mousemove', onMouseMove);
			canvas.addEventListener('touchstart', onMouseDown, { passive: false });
			canvas.addEventListener('touchmove', onMouseMove, { passive: false });
			canvas.addEventListener('click', onCanvasClick);
			document.addEventListener('pointerup', onMouseUp);
		}

		function removeListeners() {
			canvas.removeEventListener('mousedown', onMouseDown);
			canvas.removeEventListener('mousemove', onMouseMove);
			canvas.removeEventListener('touchstart', onMouseDown);
			canvas.removeEventListener('touchmove', onMouseMove);
			canvas.removeEventListener('click', onCanvasClick);
			document.removeEventListener('pointerup', onMouseUp);
		}

		if (editing) {
			addListeners();
		}

		drawCanvas()

		return () => {
			if (editing) {
				removeListeners();
			}
		};
	}, [editing])

	useEffect(() => {
		drawCanvas()
	}, [peopleFilter])

	const setData = (data) => {
		dataRef.current = data
		setDataInternal(data)
		console.log("Data updated")
		drawCanvas()
	}

	const onMouseDown = (e) => {
		console.log("MouseDown: " + e.type)
		let clickTime = Date.now()

		const canvas = canvasRef.current
		const ctx = canvas.getContext('2d')
		const rect = canvas.getBoundingClientRect(); // Get canvas position

		let newX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
		let newY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;

		newX = newX - rect.left;         // X coordinate within canvas
		newY = newY - rect.top;          // Y coordinate within canvas
		let uniquePeople = getFilteredPeople()
		let minutes = ((newY - calendarTopMargin) / canvasHeight) * 1440
		let day = Math.floor((newX - calendarLeftMargin) / (uniquePeople.length * personWidth))
		let person = Math.floor(((newX - calendarLeftMargin) - (day * uniquePeople.length * personWidth)) / personWidth)
		console.log(newX, newY)
		console.log("Minutes day person", minutes, day, person)


		let nodeClicked = false
		for (let calendarEvent of dataRef.current.calendarEvents) {

			let minutesStart = timeToMinutes(calendarEvent.start)
			let minutesEnd = timeToMinutes(calendarEvent.end, true)

			if (calendarEvent.people[people[person]]
				&& Math.min(minutesStart, minutesEnd) < minutes
				&& Math.max(minutesStart, minutesEnd) > minutes
				&& calendarEvent.days[days[day]]) {
				console.log("Clicked " + JSON.stringify(calendarEvent))
				if (calendarEvent.id == null) {
					calendarEvent.id = getUniqueId()
				}
				setEditingData(calendarEvent)
			}

			// // console.log(`MouseDown: (${locationNode.x},${locationNode.y})`)
			// let node = dataRef.current.nodes.find(n => n.id === locationNode.id)
			// let text = node?.name
			// let width = ctx.measureText(text).width;
			// let leftX = locationNode.x - (0.5 * (width + xMarg))
			// let rightX = locationNode.x + (0.5 * (width + xMarg))
			// let topY = locationNode.y - (0.5 * (nodeHeight))
			// let bottomY = locationNode.y + (0.5 * (nodeHeight))

			// if (newX >= leftX && newX <= rightX && newY >= topY && newY <= bottomY) {
			// 	nodeClicked = true
			// 	console.log("Clicked: " + locationNode.id + " " + text)
			// 	console.log(selectedNodeLocationRef.current)
			// 	if (clickedNodeRef.current?.id === locationNode.id && clickTime - lastClickTimeRef.current < debounceInterval) {
			// 		console.log("Same node: debounce skip")
			// 		break
			// 	}

			// 	clickedNodeRef.current = locationNode

			// 	if (actionRef.current === "2") {
			// 		connect(selectedNodeLocationRef.current?.id, locationNode.id)
			// 	}

			// 	if (selectedConnectionRef.current == null) {
			// 		console.log("Set selected ref: " + locationNode.id)
			// 		selectedNodeLocationRef.current = locationNode
			// 		selectedNodeRef.current = node
			// 	}
			// 	clickOffsetXRef.current = newX - locationNode.x
			// 	clickOffsetYRef.current = newY - locationNode.y
			// 	// drawTree(canvas, ctx)
			// 	break
			// }
		}

		if (!nodeClicked) {
			clickedNodeRef.current = null
		}

		isMouseDownRef.current = true
		lastClickTimeRef.current = clickTime
	}

	const onMouseUp = (e) => {
		console.log("MouseUp")
		isMouseDownRef.current = false
	}

	const onMouseMove = (e) => {
		if (isMouseDownRef.current && actionRef.current === "3" && selectedNodeLocationRef.current != null) {
			e.preventDefault()

			const canvas = canvasRef.current
			const ctx = canvas.getContext('2d')
			const rect = canvas.getBoundingClientRect(); // Get canvas position
			let newX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
			let newY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;

			newX = newX - rect.left;         // X coordinate within canvas
			newY = newY - rect.top;          // Y coordinate within canvas
			selectedNodeLocationRef.current.x = Math.round(newX - clickOffsetXRef.current)
			selectedNodeLocationRef.current.y = Math.round(newY - clickOffsetYRef.current)
			// console.log(`Move: (${selectedNodeLocationRef.current.x},${selectedNodeLocationRef.current.y})`)
			// drawTree(canvas, ctx)
		}
	}

	const onCanvasClick = (e) => {
		let canvas = e.target

		console.log("Click action: " + actionRef.current)
		const rect = canvas.getBoundingClientRect(); // Get canvas position
		let newX = Math.round(e.clientX - rect.left);         // X coordinate within canvas
		let newY = Math.round(e.clientY - rect.top);          // Y coordinate within canvas
		console.log(`Clicked at: x=${newX}, y=${newY}`);
		// if (clickedNodeRef.current == null && actionRef.current === "1") {
		// 	let newLocationData = { ...locationData }
		// 	let newLocationNode = { id: selectedNodeRef.current.id, x: newX, y: newY }
		// 	selectedNodeLocationRef.current = newLocationNode
		// 	newLocationData.nodes.push(newLocationNode)
		// 	setLocationData(newLocationData)
		// 	let newData = { ...dataRef.current }
		// 	newData.nodes.push(selectedNodeRef.current)
		// 	setData(newData)
		// }
	}

	const exitEditor = () => {
		console.log("saving:" + JSON.stringify(dataRef.current))
		update(dataRef.current)
		exit()
	}

	const onClickEdit = () => {
		edit()
	}

	const onClickCopyImage = async () => {
		try {
			const blob = await new Promise(resolve => canvasRef.current.toBlob(resolve, 'image/png'));
			const item = new ClipboardItem({ 'image/png': blob });
			await navigator.clipboard.write([item]);

			setCopyState("Copied!")
		} catch (err) {
			console.error('Failed to copy image:', err);
			setCopyState("Copy error!")
		}
	}

	const onClickDownloadImage = () => {
		const image = canvasRef.current.toDataURL('image/png'); // You can use 'image/jpeg' too

		const link = document.createElement('a');
		link.href = image;
		link.download = 'canvas-image.png'; // Filename for download
		link.click();
		setDownloadState("Downloaded!")
	}

	const onClickDelete = () => {
		if (selectedConnectionRef.current != null) {
			let newData = { ...dataRef.current }
			newData.connections = newData.connections.filter(c => {
				console.log("compare: " + JSON.stringify(c) + " : " + JSON.stringify(selectedConnectionRef.current) + " : " + (c !== selectedConnectionRef.current))
				return c !== selectedConnectionRef.current
			})
			selectedConnectionRef.current = null
			setData(newData)
		}// else if (selectedNodeLocationRef.current != null) {
		// 	let newData = { ...dataRef.current }
		// 	newData.nodes = newData.nodes.filter(n => n.id !== selectedNodeLocationRef.current.id)
		// 	newData.connections = newData.connections.filter(c => c.to !== selectedNodeLocationRef.current.id && c.from !== selectedNodeLocationRef.current.id)

		// 	let newLocationData = { ...locationData }
		// 	newLocationData.nodes = newLocationData.nodes.filter(n => n.id !== selectedNodeLocationRef.current.id)

		// 	selectedConnectionRef.current = null
		// 	setData(newData)
		// 	setLocationData(newLocationData)
		// }
	}

	const handleNameChange = (name) => {
		let newData = { ...editingData }
		newData.name = name
		setEditingData(newData)
	}

	const handlePersonChange = (person) => {
		let newData = { ...editingData }
		newData.people[person] = !editingData.people[person]
		setEditingData(newData)
	}

	const handleDayChange = (day) => {
		let newData = { ...editingData }
		newData.days[day] = !editingData.days[day]
		setEditingData(newData)
	}

	const handleStartChange = (timeStr) => {
		let newData = { ...editingData }
		newData.start = timeStr
		setEditingData(newData)
	}

	const handleEndChange = (timeStr) => {
		let newData = { ...editingData }
		newData.end = timeStr
		setEditingData(newData)
	}

	const handleSubmitClick = () => {
		let calendarEvent = { ...editingData }
		if (validateData(calendarEvent)) {
			console.log("valid")
			let data = { ...dataRef.current }

			let index = -1
			if (calendarEvent.id != null) {
				index = data.calendarEvents.findIndex(item => item.id === calendarEvent.id)
			}

			if (index > -1) {
				data.calendarEvents[index] = calendarEvent
			} else {
				data.calendarEvents.push(calendarEvent)
			}
			dataRef.current = data

			let newEditingData = JSON.parse(JSON.stringify(calendarEvent))
			newEditingData.id = getUniqueId()
			newEditingData.name = ""
			setEditingData(newEditingData)
			console.log("all data")
			console.log(dataRef.current)

			setDataInternal(data)
			drawCanvas()
		} else {
			console.log("invalid")
		}
	}

	const validateData = (calendarEvent) => {

		let errors = []

		if (calendarEvent.name == null || calendarEvent.name.length === 0) {
			errors.push("Name is empty")
		}

		if (Object.keys(calendarEvent.people).length === 0) {
			errors.push("No people are selected")
		}

		if (Object.keys(calendarEvent.days).length === 0) {
			errors.push("No days are selected")
		}

		if (calendarEvent.start == null || calendarEvent.start.length === 0) {
			errors.push("Start is empty")
		}

		if (calendarEvent.end == null || calendarEvent.end.length === 0) {
			errors.push("End is empty")
		}

		if (errors.length === 0) {
			return true
		} else {
			console.log(JSON.stringify(errors))
			return false
		}
	}

	const drawCanvas = () => {
		console.log("drawCanvas: " + JSON.stringify(dataRef.current))

		const canvas = canvasRef.current
		const ctx = canvas.getContext('2d')

		let uniquePeople = getFilteredPeople()

		let width = 7 * personWidth * uniquePeople.length + calendarLeftMargin
		let height = canvasHeight + calendarTopMargin

		canvas.width = width
		canvas.height = height

		console.log(days)
		console.log(uniquePeople)
		ctx.fillStyle = "black"
		for (let day of days) {
			let dayX = (personWidth * uniquePeople.length) * days.indexOf(day) + calendarLeftMargin
			console.log(day + " " + dayX + " " + dayLabelY)
			ctx.fillText(day, dayX + textMargin, dayLabelY);
			ctx.lineWidth = 4
			ctx.beginPath()
			ctx.moveTo(dayX, 0)
			ctx.lineTo(dayX, height)
			ctx.stroke()

			for (let person of uniquePeople) {
				console.log(person + " " + dayX + " " + personLabelY)
				ctx.fillText(person, dayX + textMargin, personLabelY);
				dayX += personWidth

				ctx.lineWidth = 2
				ctx.beginPath()
				ctx.moveTo(dayX, 0)
				ctx.lineTo(dayX, height)
				ctx.stroke()
			}
		}

		const halfHourHeight = canvasHeight / 24 / 2
		let y = calendarTopMargin
		for (let hour = 0; hour < 24; hour++) {
			ctx.beginPath()
			ctx.moveTo(0, y)
			ctx.lineTo(width, y)
			ctx.stroke()
			y += halfHourHeight
			ctx.fillText(getHourText(hour), 0, y);
			y += halfHourHeight
		}


		for (let calendarEvent of dataRef.current.calendarEvents) {
			console.log("drawing event: " + calendarEvent.name)
			for (let day in calendarEvent.days) {
				// console.log("drawing day: " + day)
				if (!calendarEvent.days[day]) {
					continue
				}

				let dayX = (personWidth * uniquePeople.length) * days.indexOf(day)

				for (let person in calendarEvent.people) {
					if (!calendarEvent.people[person] || !uniquePeople.includes(person)) {
						continue
					}

					let x = dayX + (personWidth * uniquePeople.indexOf(person)) + calendarLeftMargin

					// console.log("drawing person: " + person + " : " + x);

					let startMinutes = timeToMinutes(calendarEvent.start)
					let endMinutes = timeToMinutes(calendarEvent.end, true)

					let startY = (startMinutes / 1440) * canvasHeight
					let endY = (endMinutes / 1440) * canvasHeight

					let y = startY + calendarTopMargin
					let height = endY - startY
					let category = dataInternal?.categories?.[calendarEvent.category]
					ctx.fillStyle = category?.color || "skyblue"
					ctx.fillRect(x, y, personWidth, height)
					ctx.strokeRect(x, y, personWidth, height)

					const words = calendarEvent.name.split(' ');
					const lineHeight = 15
					let line = '';

					y += lineHeight
					ctx.fillStyle = "black"
					for (let n = 0; n < words.length; n++) {
						const testLine = line + words[n] + ' ';
						const metrics = ctx.measureText(testLine);
						const testWidth = metrics.width;

						if (testWidth > personWidth && n > 0) {
							ctx.fillText(line, x + textMargin, y);
							line = words[n] + ' ';
							y += lineHeight;
						} else {
							line = testLine;
						}
					}
					ctx.fillText(line, x + textMargin, y);
				}
			}
		}
		updateStats()
	}

	const updateStats = () => {
		let newStats = {}
		for (let category of dataRef.current.categories) {
			newStats[category.name] = {}
		}
		newStats["Uncategorized"] = {}
		newStats["Overbooked"] = {}
		for (let person of people) {
			let total = 0
			let overbooked = 0
			for (let day of days) {
				// console.log("Calculating stats for " + person + " on " + day)
				let events = [...dataRef.current.calendarEvents.filter(event => event.people[person] && event.days[day])]
				for (let event of events) {
					event.startMin = timeToMinutes(event.start)
					event.endMin = timeToMinutes(event.end, true)
				}
				events.sort((a, b) => a.startMin - b.startMin)

				for (let i = 0; i < events.length; i++) {
					let event = events[i]

					let duration = event.endMin - event.startMin

					if (event.category != null) {
						let catName = dataRef.current.categories[event.category].name
						if (newStats[catName][person] == null) {
							newStats[catName][person] = 0
						}

						newStats[catName][person] += duration
						total += duration
						console.log("Event: " + event.name + " Duration: " + duration + " Total: " + newStats[catName][person])
					} else {
						console.log("Category null for event: " + event.name)
					}


					let inc = 1
					let latestTimeCovered = event.startMin
					while (true) {
						let nextEvent = events[i + inc]
						if (nextEvent == null) {
							break
						}
						if (nextEvent.startMin >= event.endMin) {
							break
						}

						let overlapStart = Math.max(latestTimeCovered, nextEvent.startMin)
						let overlapEnd = Math.min(event.endMin, nextEvent.endMin)
						latestTimeCovered = overlapEnd
						let overlapDuration = overlapEnd - overlapStart
						overbooked += overlapDuration

						if (latestTimeCovered >= event.endMin) {
							break
						}
						inc += 1
					}
				}
			}

			let uncategorized = (7 * 24 * 60) - total + overbooked
			newStats["Uncategorized"][person] = uncategorized
			newStats["Overbooked"][person] = overbooked
		}
		console.log(newStats)
		setStats(newStats)
	}

	const timeToMinutes = (timeStr, isEnd) => {
		const [h, m] = timeStr.split(":").map(Number);

		if (isEnd && m === 0 && h === 0) {
			return 24 * 60;
		}

		return h * 60 + m;
	}

	const getHourText = (hour) =>{
		let text = hour%12;
		if(text === 0){
			text = "12:00"
		}else{
			text = text + ":00"
		}
		return text
	}

	const getUniquePeople = () => {
		let peopleSet = new Set()
		for (let calendarEvent of dataRef.current.calendarEvents) {
			console.log(calendarEvent)
			console.log(calendarEvent.people)
			for (let person in calendarEvent.people) {
				if (calendarEvent.people[person]) {
					peopleSet.add(person)
				}
			}
		}

		let uniquePeople = [...peopleSet]
		uniquePeople.sort((a, b) => people.indexOf(a) - people.indexOf(b))
		return uniquePeople
	}

	const getFilteredPeople = () => {
		return getUniquePeople().filter(p => peopleFilter[p] == null)
	}

	const handleNewCategoryNameChange = (name) => {
		let newCat = { ...newCategory }
		newCat.name = name
		setNewCategory(newCat)
	}

	const handleNewCategoryColorChange = (color) => {
		let newCat = { ...newCategory }
		newCat.color = color
		setNewCategory(newCat)
	}

	const createCategory = () => {
		if (newCategory.name != null && newCategory.name.length > 0) {
			let data = { ...dataRef.current }
			if (data.categories == null) {
				data.categories = []
			}
			data.categories.push(newCategory)
			dataRef.current = data
			setDataInternal(data)
		}
	}

	const selectCategory = (index) => {
		let newData = { ...editingData }
		newData.category = index
		setEditingData(newData)
	}

	const updatePeopleFilter = (person) => {
		let data = { ...peopleFilter }
		console.log("updatePeopleFilter: " + person)
		console.log(JSON.stringify(data))
		if (data[person] != null) {
			console.log("not null")
			delete data[person]
		} else {
			console.log("null")
			data[person] = false
		}
		console.log(JSON.stringify(data))
		setPeopleFilter(data)
	}

	return (
		<div>
			<Container fluid>
				<Row>
					<Col lg={editing ? 6 : 12}>
					{editing ? <>
						<button onClick={onClickDelete}>Delete</button>
						<button onClick={exitEditor}>Exit</button><br />
					</>
						: <div>
							<button onClick={onClickEdit}>Edit</button>
							<button onClick={onClickCopyImage}>{copyState}</button>
							<button onClick={onClickDownloadImage}>{downloadState}</button>
						</div>
					}
					<div className='scroll'>
					<table>
						<thead>
							<th>Categories</th>
							{people.map((person) => (
								<th key={person}><input type='checkbox' checked={peopleFilter[person] == null} onChange={() => updatePeopleFilter(person)}></input>{person}</th>
							))}
						</thead>
						<tbody>
							{[...dataInternal.categories, ...["Uncategorized", "Overbooked"]].map((cat) => (
								<tr key={cat.name == null ? cat : cat.name}>
									<td>{cat.name == null ? cat : cat.name}:</td>
									{people.map((person) => (
										<td key={person}>{(stats[cat.name == null ? cat : cat.name]?.[person]) / 60.0}</td>
									))}
								</tr>
							))}
						</tbody>
					</table>
					</div>
					{!editing ? null :

						<div className="settings-block">
							<div className="settings-block">
								<span>Event name</span><input id="name" value={editingData.name} onChange={e => handleNameChange(e.target.value)} /><br />
								<span>People</span><br />
								<input id="Jennifer" type="checkbox" checked={editingData.people["Jennifer"] === true} onChange={e => handlePersonChange("Jennifer")} /> <span>Jennifer</span><br />
								<input id="Tim" type="checkbox" checked={editingData.people["Tim"] === true} onChange={e => handlePersonChange("Tim")} /> <span>Tim</span><br />
								<input id="James" type="checkbox" checked={editingData.people["James"] === true} onChange={e => handlePersonChange("James")} /> <span>James</span><br />
								<input id="Adelaide" type="checkbox" checked={editingData.people["Adelaide"] === true} onChange={e => handlePersonChange("Adelaide")} /> <span>Adelaide</span><br />
								<input id="Therese" type="checkbox" checked={editingData.people["Therese"] === true} onChange={e => handlePersonChange("Therese")} /> <span>Therese</span><br />
							</div>
							<div className="settings-block">
								<span>Days</span><br />
								<input id="Sunday" type="checkbox" checked={editingData.days["Sunday"] === true} onChange={e => handleDayChange("Sunday")} /> <span>Sunday</span><br />
								<input id="Monday" type="checkbox" checked={editingData.days["Monday"] === true} onChange={e => handleDayChange("Monday")} /> <span>Monday</span><br />
								<input id="Tuesday" type="checkbox" checked={editingData.days["Tuesday"] === true} onChange={e => handleDayChange("Tuesday")} /> <span>Tuesday</span><br />
								<input id="Wednesday" type="checkbox" checked={editingData.days["Wednesday"] === true} onChange={e => handleDayChange("Wednesday")} /> <span>Wednesday</span><br />
								<input id="Thursday" type="checkbox" checked={editingData.days["Thursday"] === true} onChange={e => handleDayChange("Thursday")} /> <span>Thursday</span><br />
								<input id="Friday" type="checkbox" checked={editingData.days["Friday"] === true} onChange={e => handleDayChange("Friday")} /> <span>Friday</span><br />
								<input id="Saturday" type="checkbox" checked={editingData.days["Saturday"] === true} onChange={e => handleDayChange("Saturday")} /> <span>Saturday</span><br />
							</div>
							<div className="settings-block">
								<span>Start</span> <input id="start" type="time" value={editingData.start} onChange={e => handleStartChange(e.target.value)} /><br />
								<span>End</span> <input id="end" type="time" value={editingData.end} onChange={e => handleEndChange(e.target.value)} />
							</div>
							<div className="settings-block">

								{dataInternal.categories != null ? dataInternal.categories.map((category, index) => (
									<>
										<input type="radio" name="category" key={index} value={category} checked={editingData.category === index} onChange={e => selectCategory(index)} />
										<span>{category.name}</span>
										<br />
									</>
								))
									: null}
								<span>New Category:</span><input onChange={e => handleNewCategoryNameChange(e.target.value)} /><input type="color" onChange={e => handleNewCategoryColorChange(e.target.value)} /><input type="button" value="Create" onClick={e => createCategory()} />
							</div>
							<br />
							<input id="submit" type="button" value="Submit" onClick={e => handleSubmitClick()} /><br />
						</div>
					}
					</Col>
					<Col>
					<div className="block scroll">
						<canvas ref={canvasRef} id='canvas'></canvas>
					</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

function getUniqueId() {
	return Math.random().toString(36).substring(2, 5) + Date.now().toString(36);
}

export default Calendar